<c11n-button id="triageSummaryContinueBTN" [labelText]="continueButtonLabel" [fullWidth]="true"
  (clickEvent)="onContinueClick()">
</c11n-button>
<app-cancel></app-cancel>
<div class="tax-upload-card-container">
  <div class="side-info">
    <div class="c11n-text-md-bold">{{content.title}}</div>
    
    <section class="address-section">
      <div class="c11n-text-sm-bold">{{content.subtitle1}}</div>
      <address>
        <div>{{content.vanguard}}</div>
        <div>{{content.address1Line1}}</div>
        <div>{{content.address1Line2}}</div>
      </address>
    </section>
    
    <section class="address-section">
      <div class="c11n-text-sm-bold">{{content.subtitle2}}</div>
      <address>
        <div>{{content.vanguard}}</div>
        <div>{{content.address2Line1}}</div>
        <div>{{content.address2Line2}}</div>
      </address>
    </section>
  </div>
</div>
